import { render, staticRenderFns } from "./MaterialIndexView.vue?vue&type=template&id=9d9a701e"
import script from "./MaterialIndexView.vue?vue&type=script&lang=js"
export * from "./MaterialIndexView.vue?vue&type=script&lang=js"
import style0 from "./MaterialIndexView.vue?vue&type=style&index=0&id=9d9a701e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports